export const DSS_REGISTERED = 'dss:registered';
export const DSS_UNREGISTERED = 'dss:unregistered';
export const DSS_LOOKUP_MERCURY_EVENT = 'event:directory.lookup';
export const DSS_SEARCH_MERCURY_EVENT = 'event:directory.search';
export const DSS_LOOKUP_RESULT = 'dss:lookup.result';
export const DSS_RESULT = 'dss:result';
export const DSS_SERVICE_NAME = 'directorySearch';
export const SEARCH_TYPES = {
  PERSON: 'PERSON',
  CALLING_SERVICE: 'CALLING_SERVICE',
  EXTERNAL_CALLING: 'EXTERNAL_CALLING',
  ROOM: 'ROOM',
  ROBOT: 'ROBOT',
};
export const LOOKUP_DATA_PATH = 'lookupResult.entities';
export const LOOKUP_FOUND_PATH = 'lookupResult.entitiesFound';
export const LOOKUP_NOT_FOUND_PATH = 'lookupResult.entitiesNotFound';
export const LOOKUP_REQUEST_KEY = 'lookupValues';
export const SEARCH_DATA_PATH = 'directoryEntities';
